import { SynagogueOutlineIcon } from './SynagogueOutlineIcon';

/**
 * author: Google
 * id D070E9A9-6327-4F19-ADBC-A24A15398C7F
 * name synagogue-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/synagogue-outline.svg
 * tags
 * - Places 
 * - Religion 
 */
export const JewishOutlineIcon = SynagogueOutlineIcon;
export default JewishOutlineIcon